import { Directive, Input, Output, EventEmitter, ElementRef, HostListener, OnInit} from '@angular/core';

@Directive({
  selector: '[drag]'
})
export class DragDirective implements OnInit{
  private topStart:number;
  private leftStart:number;
  private _allowDrag:boolean = true;
  private _md:boolean = false;
  private _handle: HTMLElement;
  private _top: number = 0;
  private _boundsWidth: number = 0;
  private _boundsHeight: number = 0;

  constructor(public element: ElementRef) {
  }


  ngOnInit(){
    // css changes
    if(this._allowDrag){
      this.element.nativeElement.style.position = 'relative';
      this.element.nativeElement.className += ' cursor-draggable';
    }
    let boundsRect = this.bounds.getBoundingClientRect();
    this._boundsWidth = boundsRect.width;
    this._boundsHeight = boundsRect.height;
    this._top = Number(this.element.nativeElement.style.top.replace('px', ''));
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event:MouseEvent) {
    if(event.button === 2 || (this._handle !== undefined && event.target !== this._handle))
      return; // prevents right click drag, remove his if you don't want it
    this.md = true;
    this.topStart = event.clientY - this.element.nativeElement.style.top.replace('px','');
    this.leftStart = event.clientX - this.element.nativeElement.style.left.replace('px','');
  }

  @HostListener('document:mouseup', [ '$event' ])
  onMouseUp(event:MouseEvent) {
    this.md = false;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event:MouseEvent) {
    //console.dir(event.target)
    if( this.md && this._allowDrag ){

      let top = event.clientY - this.topStart;
      let oldTop = this.element.nativeElement.style.top;

      this.element.nativeElement.style.top = top + 'px';

      let rect = this.element.nativeElement.getBoundingClientRect();
      let boundsRect = this.bounds.getBoundingClientRect();
      
      if (rect.top > boundsRect.top || rect.bottom < boundsRect.bottom) {
        this.element.nativeElement.style.top = oldTop;
      }
      this._top = Number(this.element.nativeElement.style.top.replace('px', ''));
      this._boundsWidth = boundsRect.width;
      this._boundsHeight = boundsRect.height;
    }
  }

  @HostListener('document:mouseleave', ['$event'])
  onMouseLeave(event:MouseEvent) {
    this.md = false;
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event:TouchEvent) {
    this.md = true;
    this.topStart = event.changedTouches[0].clientY - this.element.nativeElement.style.top.replace('px','');
    this.leftStart = event.changedTouches[0].clientX - this.element.nativeElement.style.left.replace('px','');
    event.stopPropagation();
  }

  @HostListener('document:touchend', [ '$event' ])
  onTouchEnd() {
    this.md = false;
  }

  @HostListener('document:touchmove', ['$event'])
  onTouchMove(event:TouchEvent) {
    if(this.md && this._allowDrag){

      let top = event.changedTouches[0].clientY - this.topStart;
      let oldTop = this.element.nativeElement.style.top;

      this.element.nativeElement.style.top = top + 'px';

      let rect = this.element.nativeElement.getBoundingClientRect();
      let boundsRect = this.bounds.getBoundingClientRect();
      
      if (rect.top > boundsRect.top || rect.bottom < boundsRect.bottom) {
        this.element.nativeElement.style.top = oldTop;
      }
      this._top = Number(this.element.nativeElement.style.top.replace('px', ''));
      this._boundsWidth = boundsRect.width;
      this._boundsHeight = boundsRect.height;
    }
    event.stopPropagation();
  }

  @Input('drag')
  set allowDrag(value:boolean){
    this._allowDrag = value;
    if(this._allowDrag)
      this.element.nativeElement.className += ' cursor-draggable';
    else
      this.element.nativeElement.className = this.element.nativeElement.className
                                                  .replace(' cursor-draggable','');
  }

  @Input() 
  set ng2DraggableHandle(handle: HTMLElement){
    this._handle = handle;
  }

  @Input('bounds') bounds: any;
  @Output() dragStart = new EventEmitter<any>();
  @Output() dragEnd = new EventEmitter<any>(); 

  set md(flag: boolean) {
    this._md = flag;
    if (flag) {
      this.dragStart.emit(true);
    } else {
      this.dragEnd.emit({top: this._top, bounds: {width: this._boundsWidth, height: this._boundsHeight}});
    }
  }

  get md() {
    return this._md;
  }

}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/directives/drag.directive.ts